import MarkerClusterer from "@google/markerclusterer";
import GoogleMapsApiLoader from "google-maps-api-loader";
import mapStyle from "../utils/mapStyle";

const API_KEY = "AIzaSyBh6Up088bggh59WWHHjr_dMYNdoN0wutc";

const rad = x => (x * Math.PI) / 180;

const getIcon = (name = "") => {
  return `front/assets/dist/images/marqueur${name ? "-" + name : ""}.png`;
};

const handleLocationError = (browserHasGeolocation, infoWindow, pos) => {
  infoWindow.setPosition(pos);
  infoWindow.setContent(
    browserHasGeolocation
      ? "Error: The Geolocation service failed."
      : "Error: Your browser doesn't support geolocation."
  );
};

export default (container, opts = {}) => {
  const options = {
    center: { lat: 45.95, lng: 2.1667 },
    zoom: 6,
    styles: mapStyle,
    markers: [],
    click: () => {},
    mapTypeControl: false,
    ...opts
  };
  const containerNode = document.getElementById(container);

  return GoogleMapsApiLoader({
    libraries: ["places", "geometry"],
    apiKey: API_KEY
  })
    .then(googleApi => {
      // init map
      const map = new googleApi.maps.Map(containerNode, options);

      // create and place marker
      const markers = options.markers.map(m => {
        const marker = new google.maps.Marker({
          position: m.position,
          icon: getIcon(m.type),
          zIndex: m.type === "drive" ? 9999999 : 1,
          type: m.type,
          map
        });

        google.maps.event.addListener(marker, "mouseover", function() {
          marker.setIcon(getIcon(m.type + "-active"));
        });
        google.maps.event.addListener(marker, "mouseout", function() {
          marker.setIcon(getIcon(m.type));
        });

        google.maps.event.addListener(
          marker,
          "click",
          options.click.bind(null, m)
        );

        return marker;
      });

      var markerCluster = new MarkerClusterer(map, markers, {
        imagePath: "front/assets/dist/images/cluster/",
        maxZoom: 10,
        gridSize: 30,
        styles: [
          {
            url: "front/assets/dist/images/cluster/1.png",
            width: 53,
            height: 53,
            textColor: "#fff"
          }
        ]
      });

      const findNearest = ({ lat, lng }) => {
        if (!lat || !lng) return;

        var R = 6371; // radius of earth in km
        var distances = [];
        var closest = -1;
        const points = markers.filter(m => m.type === "drive");

        for (let i = 0; i < points.length; i++) {
          var mlat = points[i].position.lat();
          var mlng = points[i].position.lng();
          var dLat = rad(mlat - lat);
          var dLong = rad(mlng - lng);
          var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(lat)) *
              Math.cos(rad(lat)) *
              Math.sin(dLong / 2) *
              Math.sin(dLong / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c;
          distances[i] = d;
          if (closest == -1 || d < distances[closest]) {
            closest = i;
          }
        }

        // center map on nearest marker
        map.setCenter({
          lat: points[closest].position.lat(),
          lng: points[closest].position.lng()
        });

        map.setZoom(12);

        // center map on nearest marker
        new googleApi.maps.event.trigger(points[closest], "click");

        return points[closest];
      };

      const geoloc = () => {
        return new Promise((resolve, reject) => {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              function(position) {
                var pos = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                };

                resolve(pos);
              },
              () => {
                reject("We could not get your location.");
              }
            );
          } else {
            // Browser doesn't support Geolocation
            reject("no geolocation");
          }
        });
      };

      const geocode = address => {
        return fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&components=country:FR&key=${API_KEY}`
        )
          .then(res => res.json())
          .then(data => {
            if (data.error_message) {
              throw data.error_message;
            }
            return data.results[0].geometry.location;
          });
      };

      const infoWindow = new googleApi.maps.InfoWindow({ map });

      return {
        googleApi,
        map,
        markers,
        geoloc,
        geocode,
        findNearest
      };
    })
    .catch(console.error);
};



// WEBPACK FOOTER //
// ./assets/src/js/modules/Map.js